<template>
  <div>
    <top-menu/>
    <router-view/>
    <foo/>
  </div>
</template>

<script>
import TopMenu from "@/components/navigation/topMenu";
import foo from "@/components/navigation/footer";
export default {
  components: {foo, TopMenu}
}
</script>